export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "GraphAlgorithmWorker-97c53316f4ca602f695d.min.worker.js");
}
